import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import config from '../data/config.json';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = [
    {
      title: "Legal",
      items: [
        { name: "Privacy Policy", href: "/privacy" },
        { name: "Terms & Conditions", href: "/terms" }
      ]
    },
    {
      title: "Community",
      items: [
        { name: "Discord", href: "https://discord.gg/MZ6Yxn8M" },
        { name: "Twitter", href: "https://x.com/Modulo_Labs" }
      ]
    },
    {
      title: "Resources",
      items: [
        { name: "Documentation", href: "https://medium.com/@modulolabs" },
        { name: "Blog", href: "https://medium.com/@modulolabs" }
      ]
    }
  ];

  return (
    <footer className="bg-slate-900 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(99,102,241,0.05),transparent_50%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(99,102,241,0.02)_1px,transparent_1px),linear-gradient(to_bottom,rgba(99,102,241,0.02)_1px,transparent_1px)] bg-[size:14px_24px]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative">
        {/* Header decoration */}
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
          [SYSTEM::FOOTER]
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="relative group"
            >
              <div className="mb-4 relative">
                <img 
                  src={config.logos.main}
                  alt="zkMonk" 
                  className="h-10 group-hover:opacity-80 transition-opacity" /* Increased from h-8 to h-10 */
                />
                <div className="absolute -inset-1 bg-indigo-500/20 blur-lg opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <div className="font-mono text-xs text-indigo-500/60 mb-2">
                [SECURE_TRANSMISSION_ID: 0xF7A9]
              </div>
              <p className="text-slate-400 font-mono text-sm">
                Building the future of privacy with Zero-Knowledge technology
              </p>
            </motion.div>
          </div>

          {/* Links */}
          {links.map((section, index) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative group"
            >
              <div className="font-mono text-xs text-indigo-500/60 mb-4">
                [SECTION::{section.title.toUpperCase()}]
              </div>
              <ul className="space-y-2">
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    {item.href.startsWith('http') ? (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-slate-400 hover:text-indigo-400 transition-colors font-mono text-sm flex items-center group"
                      >
                        <span className="opacity-0 group-hover:opacity-100 transition-opacity mr-2 text-xs">
                          &gt;
                        </span>
                        {item.name}
                      </a>
                    ) : (
                      <Link
                        to={item.href}
                        className="text-slate-400 hover:text-indigo-400 transition-colors font-mono text-sm flex items-center group"
                      >
                        <span className="opacity-0 group-hover:opacity-100 transition-opacity mr-2 text-xs">
                          &gt;
                        </span>
                        {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="pt-8 mt-8 border-t border-slate-800 text-center relative"
        >
          <div className="font-mono text-xs text-slate-500">
            <span className="text-indigo-500/60">[TIMESTAMP::</span>
            {currentYear}
            <span className="text-indigo-500/60">]</span>
            &nbsp;Modulo Labs. All rights reserved.
          </div>

          {/* Bottom decoration */}
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-xs font-mono text-indigo-500/40">
            [END::FOOTER]
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;